import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import SearchDuplicates from './SearchDuplicates';
import Review from './Review';
import { useLocation, useNavigate } from 'react-router-dom';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { propertyListGetRequest } from 'store/properties/action';
import { isJson } from 'utils';
import TableContainer from './TableComponent';
import _ from 'lodash';
import { Button } from 'reactstrap';
import { ToastContainer } from 'react-toastify';
import { getduplicateRequest } from 'store/deduplicate/action';

const DeDuplicates = (props: any) => {
    document.title = "DTS | Zilter - Deduplicates";
    const navigate = useNavigate();    
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    };
    const query = useQuery();
    const model = query.get("model");

    const dispatch: ThunkDispatch<any, null, Action<string>> = useDispatch();
    const optionList = useSelector((state: ApplicationState) => state.properties.list);
    const dataLoading = useSelector((state: ApplicationState) => state.deduplicate.dataLoading);
    const DuplicateList = useSelector((state: ApplicationState) => state.deduplicate.list);
    const paginationDetails = useSelector((state: ApplicationState) => state.deduplicate.pagination);
    const [isPropertyOpen, setIsPropertyOpen] = useState<boolean>(true);
    const [isReviewOpen, setIsReviewOpen] = useState<boolean>(false);
    const [records, setRecords] = useState<any>([]);
    const [dataFields, setDataFields]= useState<any>([]);
    const [columns, setColumns]= useState<any>([]);
    const [listData, setListData]= useState<any>([]);
    const [selectedFields, setSelectedFields]= useState<any>([]);
    const [innitial, setInnitial]= useState<any>(true);
    const [triggerApi, setTriggerApi]: any = useState(false);
    const [pagination, setPagination] = useState<any>(
        {
            size: 50,
            page: 0,
            pages: 0,
            total: 0,
            elements: 0,
            first: true,
            last: false
        }
    )

    useEffect(() => {
        if (paginationDetails) {
            setPagination(paginationDetails);
        }
    }, [paginationDetails])

    useEffect(() => {
        let FilterObject = {pageSize: 100}
        dispatch(propertyListGetRequest(model, FilterObject));
    }, [model])

    useEffect(() => {
        let options: any = optionList && optionList.length && optionList.map((item: any) => {
            let valueJson = item.valuesJson && isJson(item.valuesJson) ? JSON.parse(item.valuesJson) : item?.valuesJson
            return { ...item, ...valueJson }
        })
        setDataFields(options)
    }, [optionList])


    useEffect(() => {
        const parsedData: any = DuplicateList && DuplicateList.length ? DuplicateList.map((item: any) => {            
            let count = item?.records?.length       
            let values = { ...item, fields: item?.groupKey, count: count }
            return values
        }) : []
        let data = parsedData && parsedData.length ? parsedData : []
        setListData(data)
        let columns: any = [] 
        let keys = ['fields', 'count']
        keys?.length && keys?.map((item: any) => {            
            columns.push({
                Header:item === 'fields' ? selectedFields.map((item: any) => item.label).join(',') : _.startCase(item),
                accessor: item,
                id: item,
                filterable: true,
                isSortable: true,
                disableFilters: true,
                show: true,
                Cell: (cellProps: any) => {
                    return  <div className="d-flex align-items-center justify-content-between">                                
                            {cellProps.row.original[item] }
                        </div>
                }
            }) 
        })
        setColumns(columns)
    }, [DuplicateList, selectedFields])

    const onChangePageSize = (value: any) => { 
        setPagination({ ...pagination, size: value, page: 0 })
    }

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        // Clear timer and cancel request on unmount
        const cleanup = () => {
            controller.abort("New request");
            clearTimeout(timer);
        };

        const timer = setTimeout(async () => {                  
            const keyString = selectedFields.map((item: any) => item.value).join(',');    
            if(keyString && model && !isPropertyOpen) {
                await dispatch(getduplicateRequest(model, keyString, pagination.page, pagination.size, () => {}, signal));  
            }            
        }, 600);
        // Cleanup on unmount or effect rerun
        return cleanup;
    }, [model, selectedFields, pagination?.page, pagination?.size, triggerApi])
    

    const pageChanged = (pageVal: any) => {
        const { pages, page } = pagination;
        const lastPage = pages;
        let newPageNo = 0;
        switch (pageVal) {
            case 'prev':
                if (page >= 1) {
                    newPageNo = page - 1;
                    setPagination({ ...pagination, page: newPageNo });
                }
                break;
            case 'next':
                if (page < lastPage) {
                    newPageNo = page + 1;
                    setPagination({ ...pagination, page: newPageNo });
                }
                break;
            case 'first':
                newPageNo = 0;
                setPagination({ ...pagination, page: 0 });
                break;
            case 'last':
                newPageNo = lastPage - 1;
                setPagination({ ...pagination, page: newPageNo });
                break;
            default:
                newPageNo = pageVal - 1;
                setPagination({ ...pagination, page: newPageNo });
                break;
        }
    };

    const goBack = (back: any) => {
        if(innitial || back) {
            navigate(-1);
        }
	};

    return (
        <React.Fragment>
            <ToastContainer />
            <SearchDuplicates 
                show={isPropertyOpen}
                onCloseClick={() => {setIsPropertyOpen(false); goBack(false)}}
                setIsReviewOpen={setIsReviewOpen}
                model={model}
                setSelectedFields={setSelectedFields}
                selectedFields={selectedFields}
                dataLoading={dataLoading}
                setIsPropertyOpen={setIsPropertyOpen}
                setInnitial={setInnitial}
                pagination={pagination}
                t={props.t}
            />
            <Review 
                show={isReviewOpen}
                onCloseClick={() => setIsReviewOpen(false)}
                records={records}  
                model={model}  
                dataFields={dataFields}   
                setTriggerApi={setTriggerApi}
                t={props.t}
            />
            <div className='hstack justify-content-between pb-1'>
                <Button color='primary' size="sm" className="btn btn-primary justify-self-start" onClick={() => goBack(true)}>
                    Back
                </Button>
                {!innitial && <Button color='primary' size="sm" className="btn btn-primary justify-self-end" onClick={() => setIsPropertyOpen(true)}>
                    Add Match Fields
                </Button>}
            </div>          
            <div>
                <TableContainer
                    columns={columns && columns.length ? columns.filter((column: any) => column.show == true) : []}
                    data={listData || []}
                    tableClass="align-middle table-nowrap"
                    theadClass="table-light text-muted"
                    thClass="border-bottom-1 table-soft-primary"
                    props={props}
                    dataLoading={dataLoading}
                    setIsReviewOpen={setIsReviewOpen}
                    setRecords={setRecords}
                    isPropertyOpen={isPropertyOpen && innitial}    
                    model={model || ''}
                    onChangePageSize={onChangePageSize}
                    pagination={pagination}                    
                    customPageSize= {pagination?.size}
                    pageChanged={pageChanged}
                    isPageSizeChange={true}
                />
            </div>
        </React.Fragment>
    );
};
export default withTranslation()(DeDuplicates);


